// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"535":"5f8c7e57f718bd1d901b","553":"bca38ddf1aa44218b65d"}[chunkId] + ".chunk.css";
};